import { Container, Stack, Grid } from '@mantine/core';
import { VirtualAddress } from '../components/dashboard/VirtualAddress';
import { ExpectedPackageForm } from '../components/dashboard/ExpectedPackageForm';
import PageTitle from '../components/common/PageTitle';
import { IconHome } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { UserService } from '../types';

const Dashboard = () => {
  const [, setId] = useState<string | null>(null);

  // fetch user data
  const fetchUserData = async () => {
    try {
      const userInfoString = sessionStorage.getItem('userInfo');
      if (userInfoString) {
        const decodedJson = JSON.parse(atob(userInfoString));
        const response = await UserService.getUserById(decodedJson.sub ? decodedJson.sub : '');
        setId(response.userId || null);
      }
    } catch (error) {
    }
  }

  // Fetch user data when the component mounts
  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <Container size="xl">
      <PageTitle
        title="Dashboard"
        description="Welcome to your OTLExpress dashboard. Manage your packages and shipments."
        size="lg"
        icon={<IconHome size={24} />}
        breadcrumbs={[{ title: 'Dashboard' }]}
        hideBack
        withBorder
      />

      <Stack gap="xl" mb="xl">
        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <div style={{ height: '100%' }}>
              <VirtualAddress />
            </div>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 6 }}>
            <div style={{ height: '100%' }}>
              <Stack gap="md" style={{ height: '100%' }}>
                <ExpectedPackageForm />
              </Stack>
            </div>
          </Grid.Col>
        </Grid>
      </Stack>
    </Container>
  );
};

export default Dashboard;

